<!-- @format -->
<template>
    <router-link
        :to="{ name: 'event', params: { id: event.id } }"
        :data-test-id="$attrs['data-test-id']">
        <div class="gst-latest-deals-card">
            <v-img
                :src="imageSrc"
                class="gst-latest-deals-card__image"
                gradient="to bottom, rgba(18,18,18, 0), rgba(18,18,18, 1)"
                :height="264"
                @error="errorLoadingImage = true">
            </v-img>
            <div class="gst-latest-deals-card__content d-flex">
                <div class="">
                    <div v-if="eventDateTime">
                        {{ eventDateTime }}
                    </div>
                </div>
                <div class="gst-latest-deals-card__title">
                    <VClamp
                        autoresize
                        :max-lines="2"
                        class="hyphens clamp">
                        {{ event.name }}
                    </VClamp>
                </div>
                <div>
                    <div v-if="venueInfoLocation">
                        {{ venueInfoLocation }}
                    </div>
                </div>
            </div>
        </div>
    </router-link>
</template>
<script>
import VClamp from 'vue-clamp';
import categoriesConstants from '@core/utils/constants/categories';

export default {
    name: 'EventCardVariant2',
    components: {
        VClamp,
    },
    props: {
        event: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            errorLoadingImage: false,
        };
    },
    computed: {
        imageSrc() {
            const { errorLoadingImage, fallbackSrc } = this;
            const { imageUrl } = this.event;

            if (errorLoadingImage) {
                return this.fallbackSrc;
            } else {
                return imageUrl || fallbackSrc;
            }
        },
        fallbackSrc() {
            let found = categoriesConstants.LIST.find(
                (item) => item.ID === this.event.classificationSegmentId
            );
            return found ? found.FALLBACK : categoriesConstants.DEFAULT_FALLBACK;
        },
        eventDateTime() {
            const { startDateTime, hasStartTime } = this.event;

            if (startDateTime) {
                return hasStartTime
                    ? this.$options.filters.dateDayTime(this.event.startDateTime)
                    : '';
            }
            return this.$t('_common:terms.dateAndTimeToBeDetermined');
        },
        venueInfoLocation() {
            const { venueName } = this.event;

            return venueName;
        },
    },
};
</script>
